import React from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import getStyled from "../../hooks/getStyled";
import FilterChipLabel from "./filterChipLabel";
import { SFClearIcon } from "../icons";

const { styled } = getStyled();

const StyledContainer = styled("div", { shouldForwardProp: false })(
  ({ theme, maxWidth }) => ({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    p: 0.5,
    height: "100%",
    ...(maxWidth && { maxWidth }),
    "& .custom-actions": {
      marginLeft: theme.spacing(1),
    },
  })
);

const StyledIcon = styled(SFClearIcon, {
  shouldForwardProp: (prop) => prop !== "styles",
})(({ theme, styles }) => ({
  marginLeft: `${theme.spacing(0.5)} !important`,
  marginRight: "0 !important",
  fontSize: "20px !important",
  borderRadius: "50%",
  ...(styles?.color && { color: `${styles.color} !important` }),
  backgroundColor: "rgba(0, 0, 0, 0.10)",
}));

const LabelForChip = ({ label, value }) => {
  if (label) {
    return `${label}: ${value}`;
  }
  return value;
};

const SFChipList = ({
  label,
  items,
  size = "small",
  variant = "primary",
  maxWidth,
  canDelete,
  customActions = null,
}) => {
  return (
    <StyledContainer maxWidth={maxWidth}>
      {label && items.length > 0 && (
        <Chip label={label} variant="clear" size="small" />
      )}
      {items.map((item, index) => (
        <Chip
          key={index}
          variant={variant}
          size={size}
          label={
            variant === "filterChip" ? (
              <FilterChipLabel label={item.label} value={item.value} />
            ) : (
              <LabelForChip label={item.label} value={item.value} />
            )
          }
          {...(item.style && { style: item.style })}
          {...(canDelete &&
            item.onDelete && {
            onDelete: item.onDelete,
            deleteIcon: (
              <StyledIcon
                {...(item.style && {
                  styles: () => item.style,
                })}
              />
            ),
          })}
          {...(item.onClick && { onClick: item.onClick })}
        />
      ))}

      {customActions && <div className="custom-actions">{customActions}</div>}
    </StyledContainer>
  );
};

SFChipList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired
  ),
  size: PropTypes.oneOf(["medium", "small"]),
  canDelete: PropTypes.bool,
  variant: PropTypes.oneOf(["primary", "filterChip"]),
  onDeleteAll: PropTypes.func,
  label: PropTypes.node,
};
export default SFChipList;
